<script lang="ts">
	import { createEventDispatcher, getContext } from 'svelte';
	import { format } from 'svelte-i18n';

	import { CardGrid, SelectCard, Button, Label } from '@Shelly/shelly-design-system';
	import type { Card } from './SelectList.types';
	import { NEW_ROOM } from '../../constants';
	import { load_image_from } from '../../helpers/interface_helpers';
	import { isCardSelect } from './SelectList.helpers';
	import type { SelectCardPropsTypes } from '@Shelly/shelly-design-system';
	import { safeTrim } from '../Dashboards/dash-helpers';
	import { mapOldCustomIconFromDBtoNew } from 'src/helpers/new-layout-helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	let newRoomStore: SvelteStore<any> = getContext('newRoomStore');
	const dispatch = createEventDispatcher();

	let className = '';
	export { className as class };
	export let cards: Card[] = [];
	export let variant: SelectCardPropsTypes['variant'] = 'checkbox';
	export let titleHighlight: string = '';
	export let allCardsRefs: { [key: string | number]: HTMLElement } = {};
	export let selectedCardsId: { id: string | number }[] = [];
	const handleClick = (card: Card) => {
		dispatch('click', card);
	};
	export let hideCustomCard = false;
	export let newLayoutCardBgColor: string = 'color-1';

	const resolveCardIcon = (
		card: Card,
		resolvedImage: string | undefined,
		hasBg: boolean,
	): string | undefined => {
		if (resolvedImage) return undefined;
		if (card.icon) return card.icon;
		if (hasBg) return undefined;
		return 'fak fa-solid-shelly';
	};
</script>

<CardGrid lg={290} sm={270} gridGap="s" noPaddingBottom>
	{#if $$slots['custom-card'] && !hideCustomCard}
		<slot name="custom-card" />
	{/if}
	{#each cards as card}
		{#if card.name === NEW_ROOM}
			<Button
				style="margin-top: 2px;"
				variant="secondary"
				icon="fas fa-plus"
				on:click={() => {
					$newRoomStore = {
						...$newRoomStore,
						newRoomEditing: true,
					};
				}}
			>
				{$format('button_card_add_room', { default: 'Add Room' })}
			</Button>
		{:else}
			{@const resolvedImage = safeTrim(card.image) ? load_image_from(card.image) : undefined}
			{@const hasBg = !!safeTrim(card.backgroundColor) || !!safeTrim(card._meta?.backgroundColor)}
			{@const resolvedIcon = mapOldCustomIconFromDBtoNew(
				resolveCardIcon(card, resolvedImage, hasBg),
			)}
			<div class="d-flex" bind:this={allCardsRefs[card.id]}>
				<SelectCard
					cardBgColor={$showNewLayout ? newLayoutCardBgColor : undefined}
					class="width-full {className}"
					type="horizontal"
					{variant}
					title={card.name}
					descriptiveText={card.descriptiveText}
					{titleHighlight}
					image={resolvedImage}
					icon={resolvedIcon}
					backgroundColor={card.backgroundColor || card._meta?.backgroundColor || 'color-0'}
					selected={isCardSelect(card, selectedCardsId)}
					disabled={card.disabled}
					on:click={() => handleClick(card)}
					hideRightSlot={card.badge === undefined}
				>
					<Label
						slot="rightBadge"
						size="xs"
						icon={card.badgeIcon || 'fas fa-gem'}
						type={card.type || 'premium'}
						value={card.badge}
						noRadiusType={card.badge === 'premium' ? 'second' : 'first'}
						style={'cursor:pointer'}
					/>
				</SelectCard>
			</div>
		{/if}
	{/each}
</CardGrid>
